import React, { createContext, useContext, useState } from 'react';

const MockAuthContext = createContext();

export const useMockAuth = () => {
  const context = useContext(MockAuthContext);
  if (!context) {
    throw new Error('useMockAuth must be used within a MockAuthProvider');
  }
  return context;
};

export const MockAuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(false);

  const signInWithGoogle = async (role) => {
    setLoading(true);
    
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Mock user data
    const mockUser = {
      uid: `mock-${role}-${Date.now()}`,
      email: `${role}@example.com`,
      displayName: role === 'customer' ? 'John Customer' : 'Business Owner',
      photoURL: `https://ui-avatars.com/api/?name=${role}&background=random`
    };
    
    setCurrentUser(mockUser);
    setUserRole(role);
    setLoading(false);
    
    return { user: mockUser };
  };

  const logout = async () => {
    setLoading(true);
    await new Promise(resolve => setTimeout(resolve, 500));
    setCurrentUser(null);
    setUserRole(null);
    setLoading(false);
  };

  const updateUserProfile = async (updates) => {
    // Mock profile update
    console.log('Mock profile update:', updates);
  };

  const value = {
    currentUser,
    userRole,
    signInWithGoogle,
    logout,
    updateUserProfile,
    loading
  };

  return (
    <MockAuthContext.Provider value={value}>
      {children}
    </MockAuthContext.Provider>
  );
};
